import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { GradeSuggestionAdapter } from './dto/grade-suggestion.adapter';
import { GradeSuggestionController } from './grade-suggestion.controller';
import { GradeSuggestion } from './grade-suggestion.entity';
import { GradeSuggestionService } from './grade-suggestion.service';
import { ScheduleModule } from '@nestjs/schedule';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([GradeSuggestion]),
    ScheduleModule.forRoot()
  ],
  controllers: [GradeSuggestionController],
  providers: [GradeSuggestionService,GradeSuggestionAdapter,ApplicationExceptionHandler,LogsService],
  exports:[GradeSuggestionService]
})
export class GradeSuggestionModule {}
